var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bodys"},[_c('van-tabbar',{attrs:{"border":true},model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},[_c('div',{staticClass:"bottons"},[_vm._v(" 底部 ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }